import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard que protege las rutas que requieren autenticación.
 * Si el usuario no tiene un JWT válido, redirige a /login.
 *
 * Uso en routing:
 *   { path: 'portal', canActivate: [authGuard], loadComponent: ... }
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  // Proveedor con clave temporal (2026-09-22, Fase 2) -- nunca true para un
  // analyst existente, ver AuthService.debeCambiarPassword(). El backend ya
  // bloquea el acceso real a los datos (check_supplier_access); esto es solo
  // la redirección de conveniencia para no mostrar una pantalla rota.
  const CAMBIAR_PASSWORD_PATH = '/proveedor/cambiar-password';
  if (auth.debeCambiarPassword() && state.url !== CAMBIAR_PASSWORD_PATH) {
    return router.createUrlTree([CAMBIAR_PASSWORD_PATH]);
  }

  return true;
};

/**
 * Guard que protege rutas exclusivas para analistas internos.
 * Redirige a /unauthorized si el rol no es "analyst".
 */
export const analystGuard: CanActivateFn = (_route, _state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  if (!auth.isAnalyst()) {
    return router.createUrlTree(['/unauthorized']);
  }

  return true;
};
